import { useEffect, useState } from 'react'
import { BillType, FullBillingInfo } from '../all-types'
import { useAppSelector } from '../redux-store/hooks'

const DEFAULT_FINAL_BILLING_INFO: FullBillingInfo = {
  totalItemsCostRaw: 0,
  totalDiscountIssued: 0,
  totalTaxCharged: 0,
  TaxChargeSheetView: {},
  finalBillAmount: 0,
}

const calculateFinalTotal = (fullBill: BillType) => {
  const tempBillingInfo = { ...DEFAULT_FINAL_BILLING_INFO }
  try {
    const { items } = fullBill
    tempBillingInfo.TaxChargeSheetView = {}
    tempBillingInfo.extraInfo = {}
    tempBillingInfo.extraInfo.roundOff = '0.00'
    items?.forEach((item) => {
      tempBillingInfo.totalItemsCostRaw += item.billingInfo.rawAmount
      tempBillingInfo.totalDiscountIssued += item.billingInfo.totalDiscountGiven
      tempBillingInfo.totalTaxCharged += item.billingInfo.totalTaxCharged
      if (item.billingInfo.totalTaxCharged > 0) {
        item.billingInfo.tax.taxInfo?.forEach((tax) => {
          const taxName = tax.taxComponent.taxName
          if (tempBillingInfo.TaxChargeSheetView[taxName]) {
            tempBillingInfo.TaxChargeSheetView[taxName] += tax.taxAmount
          } else {
            tempBillingInfo.TaxChargeSheetView[taxName] = tax.taxAmount
          }
          tempBillingInfo.extraInfo![taxName] =
            `${tax.taxComponent.taxName} ${tax.taxComponent.applicableTax}%`
        })
        item?.billingInfo?.discounts?.discountsInfo?.forEach((discount) => {
          const discountName = discount.discountComponent.discountName
          tempBillingInfo.extraInfo!['discount'] =
            `${discountName ?? 'discount'} ${discount.discountComponent.applicableDiscount}%`
          tempBillingInfo.extraInfo!['discountPercentage'] =
            discount.discountComponent.applicableDiscount.toString()
          tempBillingInfo.extraInfo!['discountName'] = discountName
        })
      }
      tempBillingInfo.finalBillAmount = Number(
        (
          tempBillingInfo.finalBillAmount + item.billingInfo.finalAmount
        ).toFixed(2)
      )
    })

    const finalBillAmountWithDecimals = Number(
      tempBillingInfo.finalBillAmount.toFixed(2)
    )
    const roundedFinalBillAmount = Math.floor(finalBillAmountWithDecimals)

    tempBillingInfo.finalBillAmount = roundedFinalBillAmount
    tempBillingInfo.extraInfo.roundOff = (
      finalBillAmountWithDecimals - roundedFinalBillAmount
    ).toFixed(2)
  } catch (e) {
    console.error(e)
  }
  return tempBillingInfo
}

const useCurrentBill = () => {
  const bill = useAppSelector((state) => state.table.selectedTable?.billSession)
  const [fullBill, setFullBill] = useState(bill)

  useEffect(() => {
    if (bill) {
      const bInfo = calculateFinalTotal(bill)
      setFullBill({ ...bill, billingInfo: bInfo })
    }
  }, [bill?.items, bill?.modeOfPayment])

  return { fullBill, setFullBill }
}

export { useCurrentBill }
